import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const EditIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M13.2816 3.63798C13.6901 3.22949 14.2441 3 14.8218 3C15.3995 3 15.9535 3.22949 16.362 3.63798C16.7705 4.04647 17 4.60051 17 5.17821C17 5.7559 16.7705 6.30994 16.362 6.71843L6.60726 16.4732L2.5 17.5L3.52682 13.3927L13.2816 3.63798Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
